const uploadImage = document.getElementById('uploadImage');
const canvas = document.getElementById('editorCanvas');
const ctx = canvas.getContext('2d');
const generatedImage = document.getElementById('generatedImage');
const downloadLink = document.getElementById('downloadLink');
const effectSelector = document.getElementById('effectSelector');

let effectMaskImage = new Image();
effectMaskImage.crossOrigin = 'anonymous';
effectMaskImage.src = effectSelector.value;

let uploadedImage = null; // Variable, um das hochgeladene Bild zu speichern

effectSelector.addEventListener('change', () => {
    effectMaskImage.src = effectSelector.value;
    effectMaskImage.onload = () => {
        console.log("Effektsmaske aktualisiert:", effectMaskImage.src);
        if (uploadedImage) {
            applyEffect(uploadedImage);
        }
    };
});

function processImage(file) {
    const reader = new FileReader();
    reader.onload = (e) => {
        const img = new Image();
        img.onload = () => {
            uploadedImage = img;
            applyEffect(img);
        };
        img.src = e.target.result;
    };
    reader.readAsDataURL(file);
}

function applyEffect(img) {
    const highResolutionMultiplier = 2;
    canvas.width = effectMaskImage.width * highResolutionMultiplier;
    canvas.height = effectMaskImage.height * highResolutionMultiplier;
    ctx.scale(highResolutionMultiplier, highResolutionMultiplier);

    const aspectRatio = img.width / img.height;
    const targetWidth = canvas.width / highResolutionMultiplier;
    const targetHeight = canvas.width / aspectRatio / highResolutionMultiplier;
    const offsetY = (canvas.height - targetHeight * highResolutionMultiplier) / 2;

    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(img, 0, offsetY / highResolutionMultiplier, targetWidth, targetHeight);

    ctx.globalCompositeOperation = 'destination-in';
    ctx.drawImage(effectMaskImage, 0, 0, canvas.width / highResolutionMultiplier, canvas.height / highResolutionMultiplier);
    ctx.globalCompositeOperation = 'source-over';

    const dataURL = canvas.toDataURL('image/png');
    generatedImage.src = dataURL;
    generatedImage.style.display = 'block';
    downloadLink.href = dataURL;
    downloadLink.style.display = 'block';
}

uploadImage.addEventListener('change', (event) => {
    const file = event.target.files[0];
    if (file) {
        processImage(file);
    }
});
